// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"Select_formWrapper__kg2-R","formControl":"Select_formControl__2sydT","formLabel":"Select_formLabel__37GAX","SelectWrapper":"Select_SelectWrapper__2J1C3"};